const DEFAULT_SECTION_ORDER = [
  'header',
  'hero',
  'merch',
  'creatorsFeature',
  'creators',
  'lastChance',
  'upcoming',
  'creatorCta',
  'categories',
  'reviews',
  'newsletter',
  'checkoutSuccess',
  'footer',
];

export const defaultHomeContent = {
  header: {
    announcement: { es: 'Suscríbete y obten un 20% de descuento en tu primera compra.', en: 'Subscribe and get 20% off your first purchase.' },
    announcementCtaText: { es: 'Suscríbete Ahora', en: 'Subscribe now' },
    announcementCtaUrl: '/?login=true',
    logoUrl: '/images/logo.png',
    navLinks: [
      { label: { es: 'Explora Merch', en: 'Explore Merch' }, href: '/merch/' },
      { label: { es: 'Explora las peticiones', en: 'Explore requests' }, href: '/requests/' },
      { label: { es: 'Creadores destacados', en: 'Featured creators' }, href: '/creators/' },
    ],
    searchPlaceholder: { es: 'Buscar', en: 'Search' },
    accountUrl: '/my-account/',
  },
  hero: {
    isActive: true,
    title: { es: 'MiskiPOP', en: 'MiskiPOP' },
    subtitle: { es: 'Merch oficial con intención, estética y personalidad.', en: 'Official merch with intention, style, and personality.' },
    ctaUrl: '/merch/',
    ctaLabel: { es: 'Ver catálogo', en: 'View catalog' },
    slides: [
      { imageUrl: '/images/home/home_1x.webp', mobileImageUrl: '', linkUrl: '/merch/', buttonX: 50, buttonY: 50, mobileButtonX: 50, mobileButtonY: 50 },
    ],
  },
  merch: {
    isActive: true,
    title: { es: 'Colecciones disponibles', en: 'Available collections' },
    ctaLabel: { es: 'Ver más', en: 'View more' },
    ctaUrl: '/merch/',
    featuredLimit: 10,
    items: [
      {
        id: 'demo-roxi-shirt',
        slug: 'roxi-tshirt-ac',
        name: 'ROXI T-SHIRT A.C',
        description: { es: 'Camiseta oficial ROXI, algodón premium.', en: 'Official ROXI T-shirt, premium cotton.' },
        images: ['https://placehold.co/600x600/FF50A3/FFFFFF?text=ROXI+T'],
      },
      {
        id: 'demo-cel-peluche',
        slug: 'peluche-celiny',
        name: 'PELUCHE CELINNY',
        description: { es: 'Peluchito oficial, edición limitada.', en: 'Official plush, limited edition.' },
        images: ['https://placehold.co/600x600/FFD9EB/FFFFFF?text=PELUCHE'],
      },
      {
        id: 'demo-pack',
        slug: 'pack-coleccion-1',
        name: 'PACK COLECCIÓN 1',
        description: { es: 'Pack con stickers y pins exclusivos.', en: 'Pack with exclusive stickers and pins.' },
        images: ['https://placehold.co/600x600/FFC8E2/FFFFFF?text=PACK'],
      }
    ],
  },
  creatorsFeature: {
    isActive: true,
    eyebrow: { es: 'CREADO PARA LA COMUNIDAD', en: 'MADE FOR THE COMMUNITY' },
    title: { es: 'Descubre productos únicos para ti', en: 'Discover unique products made for you' },
    description: { es: 'Explora una selección especial de productos cuidadosamente elegidos para ofrecerte calidad, estilo y originalidad.', en: 'Explore a special selection of products carefully chosen for quality, style, and originality.' },
    ctaLabel: { es: 'Comprar ahora', en: 'Buy now' },
    ctaUrl: '/merch/',
    imageUrl: 'https://placehold.co/618x463/FF50A3/FFFFFF?text=Community',
  },
  creators: {
    isActive: true,
    title: { es: 'Explora a nuestros creadores', en: 'Explore our creators' },
    ctaLabel: { es: 'Ver más', en: 'View more' },
    ctaUrl: '/creators/',
    items: [
      {
        name: 'ROXICAKE',
        followers: '16.9M',
        label: { es: 'Suscriptores', en: 'Subscribers' },
        imageUrl: 'https://placehold.co/174x174/FF50A3/FFFFFF?text=R',
        href: '/creator/roxicake/',
      },
      {
        name: 'CELYNNEI',
        followers: '3.28M',
        label: { es: 'Suscriptores', en: 'Subscribers' },
        imageUrl: 'https://placehold.co/174x174/FF50A3/FFFFFF?text=C',
        href: '/creator/celynnei/',
      },
      {
        name: 'MARVINBLOX',
        followers: '2.48M',
        label: { es: 'Suscriptores', en: 'Subscribers' },
        imageUrl: 'https://placehold.co/174x174/FF50A3/FFFFFF?text=M',
        href: '/creator/marvinblox/',
      },
      {
        name: 'MIRYSITA',
        followers: '2.88M',
        label: { es: 'Suscriptores', en: 'Subscribers' },
        imageUrl: 'https://placehold.co/174x174/FF50A3/FFFFFF?text=Y',
        href: '/creator/mirysita/',
      },
    ],
  },
  creatorCta: {
    isActive: true,
    title: { es: '¿Listo para lanzar tu propia colección con MiskiPOP?', en: 'Ready to launch your own collection with MiskiPOP?' },
    description: { es: 'Te acompañamos en cada etapa: diseño, producción, promoción y venta.', en: 'We support you at every stage: design, production, promotion, and sales.' },
    note: { es: 'Sin riesgos. Sin complicaciones. 100% MiskiPOP.', en: 'No risk. No complications. 100% MiskiPOP.' },
    ctaLabel: { es: 'Conoce más', en: 'Learn more' },
    ctaUrl: '/merch/',
    imageUrl: 'https://placehold.co/627x627/FF50A3/white?text=MiskiPOP',
  },
 lastChance: {
  isActive: true,
  title: { es: 'Última Oportunidad', en: 'Last Chance' },
  ctaLabel: { es: 'Ver más', en: 'View more' },
  ctaUrl: '/requests/',
},
  upcoming: {
    isActive: true,
    title: { es: 'Próximamente', en: 'Coming Soon' },
    ctaLabel: { es: 'Ver más', en: 'View more' },
    ctaUrl: '/merch/',
  },
  categories: {
    isActive: true,
    title: { es: 'CATEGORÍAS', en: 'CATEGORIES' },
    subtitle: { es: 'Explora nuestros productos favoritos para coleccionistas y fans', en: 'Explore our favorite products for collectors and fans' },
    items: [
      {
        name: { es: 'Colecciones', en: 'Collections' },
        description: { es: 'Figuras, tarjetas y más para tu colección', en: 'Figures, cards, and more for your collection' },
        imageUrl: 'https://placehold.co/345x216/E8F5E9/333333?text=Colecciones',
        bgColor: '#E8F5E9',
        href: '/category/colecciones/',
      },
      {
        name: { es: 'Ropa', en: 'Apparel' },
        description: { es: 'Outfits únicos para fans con estilo', en: 'Unique outfits for fans with style' },
        imageUrl: 'https://placehold.co/345x216/FCE4EC/333333?text=Ropa',
        bgColor: '#FCE4EC',
        href: '/category/ropa/',
      },
      {
        name: { es: 'Peluches', en: 'Plushies' },
        description: { es: 'Los personajes mas cute en versión plush', en: 'The cutest characters as plushies' },
        imageUrl: 'https://placehold.co/345x216/E3F2FD/333333?text=Peluches',
        bgColor: '#E3F2FD',
        href: '/category/peluches/',
      },
      {
        name: { es: 'Paquetes', en: 'Bundles' },
        description: { es: 'Packs especiales con tus productos favoritos', en: 'Special packs with your favorite products' },
        imageUrl: 'https://placehold.co/345x216/FFF3E0/333333?text=Paquetes',
        bgColor: '#FFF3E0',
        href: '/category/paquetes/',
      },
    ],
  },
  reviews: {
    isActive: true,
    title: { es: 'NUESTROS FANS FELICES', en: 'OUR HAPPY FANS' },
    subtitle: { es: 'Nos respalda la confianza de personas que confían en nosotros', en: 'We are backed by the trust of people who believe in us' },
    benefitsTitle: { es: 'POR QUÉ COMPRAR CON MiskiPOP', en: 'WHY BUY WITH MiskiPOP' },
    items: [
      {
        name: 'Anibal Jará',
        location: 'Lima, Perú',
        product: { es: 'PELUCHE CELINNY', en: 'CELINNY PLUSH' },
        date: 'MAYO 2026',
        text: { es: 'El peluche está demasiado cute, pensé que sería pequeño pero es perfecto. Los detalles están súper bien hechos y llegó bien empaquetado.', en: 'The plush is super cute. I thought it would be small, but it is perfect. The details are very well made and it arrived nicely packed.' },
        avatarUrl: '',
        productImg: 'https://placehold.co/57x78',
      },
      {
        name: 'Valentina Lopez',
        location: 'Lima, Perú',
        product: 'ROXI T-SHIRT A.C',
        date: 'MAYO 2026',
        text: { es: 'Me encantó que el diseño no sea el típico logo gigante. Es más sutil, más usable. Literal lo puedo combinar con todo en mi día a día.', en: 'I loved that the design is not the typical giant logo. It is more subtle and wearable. I can literally match it with anything day to day.' },
        avatarUrl: '',
        productImg: 'https://placehold.co/66x81',
      },
      {
        name: 'Valentina Lopez',
        location: 'Lima, Perú',
        product: 'ROXI T-SHIRT A.C',
        date: 'MAYO 2026',
        text: { es: 'Me encantó que el diseño no sea el típico logo gigante. Es más sutil, más usable. Literal lo puedo combinar con todo en mi día a día.', en: 'I loved that the design is not the typical giant logo. It is more subtle and wearable. I can literally match it with anything day to day.' },
        avatarUrl: '',
        productImg: 'https://placehold.co/66x81',
      },
      {
        name: 'Anibal Jará',
        location: 'Lima, Perú',
        product: { es: 'PELUCHE CELINNY', en: 'CELINNY PLUSH' },
        date: 'MAYO 2026',
        text: { es: 'El peluche está demasiado cute, pensé que sería pequeño pero es perfecto. Los detalles están súper bien hechos y llegó bien empaquetado.', en: 'The plush is super cute. I thought it would be small, but it is perfect. The details are very well made and it arrived nicely packed.' },
        avatarUrl: '',
        productImg: 'https://placehold.co/57x78',
      },
    ],
    benefits: [
      { iconKey: 'shipping', title: { es: 'Envíos Seguros', en: 'Safe Shipping' }, description: { es: 'Recibe tus productos bien protegidos en todo el Perú', en: 'Receive your products safely packed across Peru' } },
      { iconKey: 'official', title: { es: 'Productos oficiales', en: 'Official products' }, description: { es: 'Trabajamos con marcas originales y de alta calidad', en: 'We work with original, high-quality brands' } },
      { iconKey: 'exclusive', title: { es: 'Diseños exclusivos', en: 'Exclusive designs' }, description: { es: 'Colecciones únicas que no encontrarás en otras tiendas', en: 'Unique collections you will not find in other stores' } },
      { iconKey: 'community', title: { es: 'Comunidad Fan', en: 'Fan community' }, description: { es: 'Únete a miles de fans y vive tu pasión al máximo', en: 'Join thousands of fans and live your passion fully' } },
    ],
  },
  newsletter: {
    isActive: true,
    badgeText: { es: 'ACCESO EXCLUSIVO', en: 'EXCLUSIVE ACCESS' },
    titlePart1: { es: 'NO TE PIERDAS ', en: 'DO NOT MISS ' },
    titlePart2: { es: 'LANZAMIENTOS', en: 'EXCLUSIVE' },
    titlePart3: { es: ' EXCLUSIVOS', en: ' LAUNCHES' },
    subtitle: { es: 'Recibe descuentos, novedades y colecciones limitadas', en: 'Get discounts, updates, and limited collections' },
    placeholder: { es: 'Escribe tu correo electrónico', en: 'Enter your email address' },
    buttonLabel: { es: 'Suscribirse', en: 'Subscribe' },
    legalText: { es: 'Los datos serán procesados y protegidos de acuerdo a la', en: 'Your data will be processed and protected according to the' },
    legalLinks: [
      { label: { es: 'Política', en: 'Privacy Policy' }, href: '/politica-de-privacidad' },
      { label: { es: 'Términos y Condiciones', en: 'Terms and Conditions' }, href: '/terminos-y-condiciones' },
    ],
    legalSuffix: { es: 'de MiskiPOP', en: 'of MiskiPOP' },
    backgroundImageUrl: '',
    legalTextColor: '#777777',
    titleColor: '#000000',
    subtitleColor: '#1a1a1a',
    legalBackgroundColor: '#ffffff',
  },
  checkoutSuccess: {
    isActive: true,
    title: { es: 'Finalizar Compra', en: 'Complete Purchase' },
    subtitle: { es: 'Compra confirmada', en: 'Purchase confirmed' },
    heading: { es: '¡Pedido Confirmado!', en: 'Order Confirmed!' },
    thanksPrefix: { es: 'Gracias por tu compra,', en: 'Thanks for your purchase,' },
    orderPrefix: { es: 'Tu pedido con código ', en: 'Your order with code ' },
    orderSuffix: { es: ' ha sido creado correctamente', en: ' has been created successfully' },
    confirmationCardTitle: { es: 'Hemos enviado una confirmación a', en: 'We have sent a confirmation to' },
    trackingCardTitle: { es: 'Puedes hacerle seguimiento a tu pedido', en: 'You can track your order' },
    trackingCardLinkLabel: { es: 'Ir a Mis Pedidos', en: 'Go to My Orders' },
    actionsTitle: { es: '¿Qué te gustaría hacer ahora?', en: 'What would you like to do now?' },
    primaryButtonLabel: { es: 'Ver mis pedidos', en: 'View my orders' },
    primaryButtonUrl: '/my-account/orders',
    secondaryButtonLabel: { es: 'Seguir comprando', en: 'Continue shopping' },
    secondaryButtonUrl: '/merch/',
    imageUrl: 'https://placehold.co/456x443/FFF0F6/FF50A3?text=Pedido+Confirmado',
  },
  footer: {
    backgroundColor: '#FAFAFA',
    logoUrl: '/images/footer-logo-big.png',
    description: { es: 'Diseñamos merch oficial con intención, estética y personalidad, para que cada fan pueda sentirse parte de algo más grande.', en: 'We design official merch with intention, style, and personality so every fan can feel part of something bigger.' },
    links: [
      { label: { es: 'Contacto / Soporte', en: 'Contact / Support' }, href: '/contacto' },
      { label: { es: 'Libro de reclamaciones', en: 'Complaints book' }, href: 'https://docs.google.com/forms/d/e/1FAIpQLSdDBempr_WG0U7fouvEGtDvVTb1SaC-Cu0pMgnlrCZJJhHglA/viewform' },
      { label: { es: 'Términos y Condiciones', en: 'Terms and Conditions' }, href: '/terminos-y-condiciones' },
      { label: { es: 'Política de Privacidad', en: 'Privacy Policy' }, href: '/politica-de-privacidad' },
      { label: { es: 'Envíos y Entregas', en: 'Shipping and Delivery' }, href: '/envios-y-entregas' },
    ],
    helpLinksTitle: { es: 'Ayuda', en: 'Help' },
    helpLinks: [
      { label: { es: 'Preguntas Frecuentes', en: 'FAQ' }, href: '/preguntas-frecuentes' },
      { label: { es: 'Envíos y Entregas', en: 'Shipping and Delivery' }, href: '/envios-y-entregas' },
      { label: { es: 'Cambios y Devoluciones', en: 'Exchanges and Returns' }, href: '/cambios-y-devoluciones' },
      { label: { es: 'Métodos de Pago', en: 'Payment Methods' }, href: '/metodos-de-pago' },
    ],
    socialDescription: { es: 'Entérate de lanzamientos y promociones exclusivas', en: 'Stay updated on launches and exclusive promotions' },
    socials: [
      { label: 'Instagram', href: 'https://www.instagram.com/miskipop_pe/', iconUrl: '/figma-icons/logo-instagram.svg' },
      { label: 'Facebook', href: 'https://www.facebook.com/miskipop.world', iconUrl: '/figma-icons/logo-facebook.svg' },
      { label: 'TikTok', href: 'https://www.tiktok.com/@', iconUrl: '/figma-icons/logo-tiktok.svg' },
      { label: 'Twitter', href: 'https://x.com/', iconUrl: '/figma-icons/twitter.svg' },
    ],
  },
  authModal: {
    loginImageUrl: '/images/banner-1.png',
    registerImageUrl: '/images/banner-2.png',
  },
};

export function localized(value, language = 'es', fallback = '') {
  if (typeof value === 'string') return value;
  
  const safeFallback = typeof fallback === 'string' ? fallback : '';
  if (!value || typeof value !== 'object') return safeFallback;
  
  if (typeof value[language] === 'string' && value[language] !== '') return value[language];
  if (typeof value.es === 'string' && value.es !== '') return value.es;
  if (typeof value.en === 'string' && value.en !== '') return value.en;
  
  if (typeof value[language] === 'string') return value[language];
  if (typeof value.es === 'string') return value.es;
  if (typeof value.en === 'string') return value.en;
  
  return safeFallback;
}

export function localizedField(item, field, language = 'es', fallback = '') {
  const safeFallback = typeof fallback === 'string' ? fallback : '';
  if (!item || typeof item !== 'object') return safeFallback;
  
  const originalValue = item[field] ?? safeFallback;
  const originalFallback = typeof originalValue === 'string' ? originalValue : safeFallback;
  // The base catalog value is the source text and must win in Spanish after an admin edit.
  if (language === 'es' && typeof originalValue === 'string' && originalValue !== '') return originalValue;
  
  return localized(item[`${field}I18n`], language, originalFallback);
}

export function setLocalizedValue(value, language, nextValue) {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return { ...value, [language]: nextValue, ...(language === 'en' ? { enReviewed: true } : {}) };
  }
  return { es: typeof value === 'string' ? value : '', en: '', [language]: nextValue, ...(language === 'en' ? { enReviewed: true } : {}) };
}

export function mergeHomeContent(value) {
  if (!value || typeof value !== 'object') return structuredClone(defaultHomeContent);

  const merged = structuredClone(defaultHomeContent);
  const creatorsFeatureFallback = value.creatorsFeature || value.creators?.feature || {};
  const creatorCtaFallback = value.creatorCta || {
    ctaUrl: value.creators?.feature?.ctaUrl,
    imageUrl: value.creators?.feature?.imageUrl,
  };
  const sectionOrder = Array.isArray(value.sectionOrder)
    ? [...value.sectionOrder.filter((key) => DEFAULT_SECTION_ORDER.includes(key)), ...DEFAULT_SECTION_ORDER.filter((key) => !value.sectionOrder.includes(key))]
    : DEFAULT_SECTION_ORDER;

  return {
    ...merged,
    ...value,
    sectionOrder,
    header: { ...merged.header, ...(value.header || {}) },
    hero: { ...merged.hero, ...(value.hero || {}) },
    merch: { ...merged.merch, ...(value.merch || {}) },
    creatorsFeature: { ...merged.creatorsFeature, ...creatorsFeatureFallback },
    creators: { ...merged.creators, ...(value.creators || {}) },
    creatorCta: { ...merged.creatorCta, ...creatorCtaFallback },
    lastChance: { ...merged.lastChance, ...(value.lastChance || {}) },
    upcoming: { ...merged.upcoming, ...(value.upcoming || {}) },
    categories: { ...merged.categories, ...(value.categories || {}) },
    reviews: { ...merged.reviews, ...(value.reviews || {}) },
    newsletter: { ...merged.newsletter, ...(value.newsletter || {}) },
    checkoutSuccess: { ...merged.checkoutSuccess, ...(value.checkoutSuccess || {}) },
    footer: { ...merged.footer, ...(value.footer || {}) },
    authModal: { ...merged.authModal, ...(value.authModal || {}) },
  };
}
